import { useEffect, useState } from 'react';
import { adPixelsConfig } from '@/lib/adPixelsConfig';
import {
  getMarketingConsent,
  setMarketingConsent,
} from '@/lib/marketingConsent';
import { isGoogleAdsActive, isMetaActive, isTikTokActive } from '@/lib/adPixelsConfig';

export default function MarketingConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const anyPixel =
      isMetaActive() || isTikTokActive() || isGoogleAdsActive();
    if (!anyPixel) return;
    if (!adPixelsConfig.requireConsent) return;
    if (getMarketingConsent() == null) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div
      dir="rtl"
      className="fixed bottom-0 inset-x-0 z-[100] border-t bg-background/95 p-4 shadow-lg"
      role="dialog"
      aria-label="הסכמה לעוגיות שיווק"
    >
      <div className="container mx-auto flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">
          אנו משתמשים בכלי מדידה ושיווק (למשל Google / Meta / TikTok) לשיפור החוויה ולמדידת קמפיינים.
          פירוט ב־
          <a href="/privacy" className="underline mx-1">מדיניות הפרטיות</a>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            className="rounded-md border px-3 py-2 text-sm"
            onClick={() => {
              setMarketingConsent('denied');
              setVisible(false);
            }}
          >
            דחייה
          </button>
          <button
            className="rounded-md bg-primary text-primary-foreground px-3 py-2 text-sm"
            onClick={() => {
              setMarketingConsent('granted');
              setVisible(false);
            }}
          >
            אישור
          </button>
        </div>
      </div>
    </div>
  );
}
